import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["startDate", "endDate"];

  selectDateRange(event) {
    const {
      detail: { selectedDates, instance },
    } = event;

    if (selectedDates.length === 2) {
      [this.startDateTarget.value, this.endDateTarget.value] = [
        instance.formatDate(selectedDates[0], instance.config.dateFormat),
        instance.formatDate(selectedDates[1], instance.config.dateFormat),
      ];
    }
  }
}
